// extracted by mini-css-extract-plugin
export var active = "_k3-2";
export var recordingDot = "_k3-1";
export var recordingIndicator = "_k3-0";